import { render, staticRenderFns } from "./CardAdminOrg.vue?vue&type=template&id=fa51e96a&"
import script from "./CardAdminOrg.vue?vue&type=script&lang=js&"
export * from "./CardAdminOrg.vue?vue&type=script&lang=js&"
import style0 from "./CardAdminOrg.vue?vue&type=style&index=0&id=fa51e96a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports